import { render, staticRenderFns } from "./holiday.vue?vue&type=template&id=3ee52580&scoped=true"
import script from "./holiday.vue?vue&type=script&lang=js"
export * from "./holiday.vue?vue&type=script&lang=js"
import style0 from "./holiday.vue?vue&type=style&index=0&id=3ee52580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee52580",
  null
  
)

export default component.exports